/**
 * @file: 修改cube信息
 * @author: xiaolong.huang@dmall.com
 */

import * as CubeTree from '../cubeTree/index';
import NextTick from '../utils/nextTick';
import Utils from '../utils/util';
import FrontCubeData from '../frontCubeData/index';

export function cubeModify(cubeId: CubeId, task: FreeObjMap): void {
    let targetCube: CubeNode = CubeTree.findByCubeId(cubeId);

    CubeTree.setCubeValue(targetCube, task);
    FrontCubeData.setValue(cubeId, task);
}

export function forceCubeModify(cubeId: CubeId, keyPath: string, value: any): void {
    let targetCube: CubeNode = CubeTree.findByCubeId(cubeId);

    Utils.setMapValueByStringKey(targetCube, keyPath, value);
}
